import React, { useMemo } from 'react';
import SalesBreakdownCardContext from '../SalesBreakdownCardContext';
import { Segment } from 'tea-component';
import { getName } from '@home/utils/common';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import './index.scss';

const SalesBreakdownCardContextTransfer = (props: any) => {
  const {
    tabMapConfig,
    categoryOptions,
    changeData,
    ...restProps
  } = props;
  const { by_tab, by_type, by_metric } = props?.data || {};
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const [revenueVal, setRevenueVal] = React.useState('');

  const { newConfig, downloadTitle } = useMemo(() => {
    const config = tabMapConfig?.[by_tab] || {};
    const { titleOptions, ...restConfig } = config || {};
    const newConfig = { ...(restConfig || {}) };
    let downloadTitle;
    // after refund的revenue特殊处理成tab
    if (titleOptions) {
      const initOptionVal = titleOptions?.[0]?.value;
      const currentValue = revenueVal || by_metric || initOptionVal;
      const title: any[] = [];
      const newOptions = titleOptions?.map((item: any) => {
        const { nameEn, nameCn, value } = item;
        const name = getName(isEn, nameEn, nameCn);
        // 获取当前选项名称，防止下载报错
        if (value === currentValue) {
          downloadTitle = name;
        }
        return {
          text: name,
          value
        };
      });

      const nameDom = <Segment
        className='dbd-sales-breakdown-card-segment'
        value={currentValue}
        onChange={(val: string) => {
          setRevenueVal(val);
          changeData?.('by_metric', val);
        }}
        options={newOptions}
      />;
      title.push({
        type: by_type,
        name: nameDom
      });
      newConfig.title = title;
      newConfig.apiDataKey = currentValue;
    }
    return { newConfig, downloadTitle };
  }, [by_metric, by_tab, by_type, changeData, isEn, revenueVal, tabMapConfig]);



  return (
    <SalesBreakdownCardContext
      changeData={changeData}
      {...restProps}
      config={newConfig}
      downloadTitle={downloadTitle}
    >
    </SalesBreakdownCardContext>
  );
};

export default SalesBreakdownCardContextTransfer;
